import React from 'react';
import { Dialog, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ReactPlayer from 'react-player';

const VideoModal = ({ open, onClose, videoUrl }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        style: {
          backgroundColor: 'black',
          boxShadow: 'none',
        }
      }}
    >
      <Box sx={{ position: 'relative', paddingTop: '56.25%' }}>
        <IconButton
          onClick={onClose}
          sx={{ position: 'absolute', top: 8, right: 8, color: 'white', zIndex: 10 }}
        >
          <CloseIcon />
        </IconButton>
        {videoUrl && (
          <ReactPlayer 
            url={videoUrl} 
            playing={open} 
            controls={true} 
            width='100%' 
            height='100%' 
            style={{ position: 'absolute', top: 0, left: 0 }}
          />
        )}
      </Box>
    </Dialog>
  );
};

export default VideoModal;
